export default () => ({
  container: {
    padding: '2rem 0',
    width: '100vw',
    minHeight: '100vh',
  },
  card: {
    width: '500px',
    margin: 'auto',
    maxWidth: '90vw',
  },
  buttonContainer: {
    margin: '2rem auto 1rem',
    display: 'block',
    width: 'fit-content',
  },
});
